import * as t from "io-ts";

export const codec = t.union([
    t.literal("inbound"),
    t.literal("outbound"),
]);
